// import EntypoIcon from '@expo/vector-icons/Entypo'

// import BackIcon from '../../components/BackIcon'
// import XTabNavIcon from '../../components/XTabNavIcon'

import BaseUIStoreWebsiteSettingOptionsOrderView from 'xui/modules/storeWebsite/BaseUIStoreWebsiteSettingOptionsOrderView'

export default class StoreWebsiteSettingOptionsOrderView extends BaseUIStoreWebsiteSettingOptionsOrderView {}
